export const FEATURE_TYPE_IDS = {
  homeEssentials: 'b5d087fe-3bcf-4714-95ca-3a65433c7206',
  workEssentials: 'b5d087fe-3bcf-4714-95ca-3a65433c7207',
  essentials: '6e2a1c4f-9b70-4d3e-8a15-c0f47b9d2e81',
  essentialsEditorial: 'c8e4a1b7-3d5f-4a92-9c6e-0b7f2d8a4e15'
} as const

export const PRIMARY_FEATURE_TYPES = [{ id: FEATURE_TYPE_IDS.essentialsEditorial, title: 'Essentials' }]

export const LEGACY_FEATURE_TYPES = [
  { id: FEATURE_TYPE_IDS.homeEssentials, title: 'Home Essentials' },
  { id: FEATURE_TYPE_IDS.workEssentials, title: 'Work Essentials' }
]

/** Map the Discover Essentials id to the SuperAdmin editorial id. */
export const toEditorialFeatureTypeIds = (ids: string[]): string[] =>
  Array.from(
    new Set(ids.map(id => (id === FEATURE_TYPE_IDS.essentials ? FEATURE_TYPE_IDS.essentialsEditorial : id)))
  )
